/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const DictionaryTypeDto = {
    CompetencyArea: 'COMPETENCY_AREA',
    Department: 'DEPARTMENT',
    EmployeeAspirationInTime: 'EMPLOYEE_ASPIRATION_IN_TIME',
    EmployeeAspirationType: 'EMPLOYEE_ASPIRATION_TYPE',
    EmployeeMobility: 'EMPLOYEE_MOBILITY',
    EmployeePosition: 'EMPLOYEE_POSITION',
    EnglishLevel: 'ENGLISH_LEVEL',
    EmployeeLeavingRiskLevel: 'EMPLOYEE_LEAVING_RISK_LEVEL',
    EmployeeSuccessionReadiness: 'EMPLOYEE_SUCCESSION_READINESS',
    Matrix: 'MATRIX',
    Region: 'REGION',
    TraditionalCounterShop: 'TRADITIONAL_COUNTER_SHOP',
    UserRole: 'USER_ROLE',
    YesNo: 'YES_NO'
} as const;

export type DictionaryTypeDto = typeof DictionaryTypeDto[keyof typeof DictionaryTypeDto];



